export default {
  id: 2,
  logo: require('@/assets/VueJS.svg'),
  name: 'vuejs',
  subtitle: 'Développer une application web en VueJS',
  description: {
    details: '<b>VueJS</b> est une librairie qui permet de créer des <b>applications web interactives</b> en se reposant sur le principe des <b>composants</b>. Grâce à cette formation vous serez en mesure de développer une application Web en VueJS.',
    goals: [
      { id: 1, content: 'Comprendre VueJS et ses applications' },
      { id: 2, content: 'Savoir développer une application Web en VueJS' },
      { id: 3, content: 'S\'interfacer avec une API REST' },
      { id: 4, content: 'Découvrir l\'éco-système VueJS' }
    ],
    needs: [
      {
        id: 1,
        title: 'PUBLIC',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/desktop.svg'), name: 'Développeur Web' },
          { id: 2, logo: require('@/assets/training/mobile.svg'), name: 'Développeur Mobile' }
        ]
      },
      {
        id: 2,
        title: 'PÉDAGOGIE',
        items: [
          { id: 1, logo: require('@/assets/training/60percent.png'), name: null }
        ]
      },
      {
        id: 3,
        title: 'PRÉ-REQUIS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/javascript.svg'), name: 'JAVASCRIPT' },
          { id: 2, logo: require('@/assets/training/tools/npm.svg'), name: 'NPM' }
        ]
      },
      {
        id: 4,
        title: 'OUTILS',
        alignItems: 'flex-start',
        items: [
          { id: 1, logo: require('@/assets/training/tools/visualStudioCode.svg'), name: 'VS CODE' },
          { id: 2, logo: require('@/assets/training/tools/npm.svg'), name: 'NPM' },
          { id: 3, logo: require('@/assets/training/tools/googleChrome.svg'), name: 'CHROME' }
        ]
      }
    ],
    time: '2 JOURS',
    price: '300 € HT',
    trainer: 'MICKAËL'
  },
  program: [
    {
      id: 1,
      title: 'DÉCOUVERTE DE VUEJS',
      items: [
        { id: 1, content: 'Concepts de base' },
        { id: 2, content: 'Comparaison avec d\'autres solutions' },
        { id: 3, content: 'Les composants' },
        { id: 4, content: 'Les directives' }
      ]
    },
    {
      id: 2,
      title: 'OUTILLAGE',
      items: [
        { id: 1, content: 'Visual Studio Code + Veture' },
        { id: 2, content: 'VueCLI' },
        { id: 3, content: 'WebPack' }
      ]
    },
    {
      id: 3,
      title: 'LES COMPOSANTS',
      items: [
        { id: 1, content: 'Création, Cycle de Vie' },
        { id: 2, content: 'Props, data, watcher, computed' },
        { id: 3, content: 'Gestion des évènements' },
        { id: 4, content: 'Design SASS' }
      ]
    },
    {
      id: 4,
      title: 'L\'ÉCOSYSTÈME',
      items: [
        { id: 1, content: 'Vue Router' },
        { id: 2, content: 'VueX' }
      ]
    },
    {
      id: 5,
      title: 'MISE EN PRODUCTION',
      items: [
        { id: 1, content: 'Mettre en production sur Firebase' }
      ]
    }
  ]
}
